import { Http } from "../Http";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { GetInsuranceDoctorsFilterDto } from "@apiModels/Insurance/GetInsuranceDoctorsFilterDto.csharp";
import { GetInsuranceDoctorsResponseDto } from "@apiModels/Insurance/GetInsuranceDoctorsResponseDto.csharp";

export interface IDoctorsApi {
  get(): Promise<DoctorDto[]>;
  getFilteredInsurance(
    request: GetInsuranceDoctorsFilterDto
  ): Promise<GetInsuranceDoctorsResponseDto>;
}

export class DoctorsApi implements IDoctorsApi {
  public get = (): Promise<DoctorDto[]> => {
    return Http.get(`/api/doctors`, null) as Promise<DoctorDto[]>;
  };

  public addFavourite = (id: string) => {
    return Http.post(`/api/doctors/insurance/favourite/${id}`, {});
  };

  public deleteFavourite = (id: string) => {
    return Http.delete(`/api/doctors/insurance/favourite/${id}`);
  };

  public getFilteredInsurance(
    request: GetInsuranceDoctorsFilterDto
  ): Promise<GetInsuranceDoctorsResponseDto> {
    const requestQuery = DoctorsApi.mapRequestToQueryUrl(request);

    return Http.get(
      `/api/doctors/insurance${requestQuery ? `?${requestQuery}` : ""}`
    );
  }

  public static mapRequestToQueryUrl(
    request: GetInsuranceDoctorsFilterDto
  ): string {
    const params = [];
    if (request.specializationId)
      params.push("specializationId=" + request.specializationId);

    if (request.filterFavourite)
      params.push("filterFavourite=" + request.filterFavourite);

    if (request.serviceId) params.push("serviceId=" + request.serviceId);

    if (request.locationIds)
      for (const location of request.locationIds)
        params.push("locationIds=" + location);

    if (request.centerIds)
      for (const center of request.centerIds)
        params.push("centerIds=" + center);

    if (request.keywords)
      for (const keyword of request.keywords)
        params.push("keywords=" + keyword);

    return params.join("&");
  }
}
